import { API_VERSIONS, asinzenAdminApi } from "client/api";

export const searchBrands = (query?: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/brands/search`, { params: query });

export const addBrand = (query?: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/brands/v2/add`, query);

export const updateBrand = (query?: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/brands/v2/update`, query);

export const deleteBrand = (id: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .delete(`/${API_VERSIONS}/admin/brands/${id}/delete`);

export const addBrandData = (query?: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/brands/add/data`, query);

export const deleteBrandData = (query?: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/brands/delete/data`, query);